package com.anjuros.website.templates.template10.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.templates.template10.components.Template10Eyebrow
import com.anjuros.website.templates.template10.components.Template10Reveal
import com.anjuros.website.templates.template10.components.Template10Title
import com.anjuros.website.templates.template10.components.template10BodyFont
import com.anjuros.website.templates.template10.components.template10HeadingFont
import com.anjuros.website.templates.template10.modules.Template10Section
import com.anjuros.website.templates.template10.modules.Template10Theme
import com.anjuros.website.templates.template10.modules.Template10Venue
import com.anjuros.website.templates.template10.modules.getColor
import com.anjuros.website.templates.template10.modules.template10Days
import com.anjuros.website.templates.template10.styles.Template10ContainerStyle
import com.anjuros.website.templates.template10.styles.Template10SectionPaddingStyle
import com.anjuros.website.templates.template10.util.ResKey
import com.anjuros.website.templates.template10.util.Template10Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Tbody
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Th
import org.jetbrains.compose.web.dom.Thead
import org.jetbrains.compose.web.dom.Tr

@Composable
fun Template10TimetableSection() {
    Column(
        modifier = Template10SectionPaddingStyle.toModifier()
            .id(Template10Section.Timetable.id)
            .fillMaxWidth()
            .backgroundColor(Template10Theme.Paper.rgb),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(modifier = Template10ContainerStyle.toModifier().gap(48.px)) {

            Template10Reveal(modifier = Modifier.fillMaxWidth()) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .flexWrap(FlexWrap.Wrap)
                        .gap(24.px),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.Bottom
                ) {
                    Column(modifier = Modifier.gap(14.px)) {
                        Template10Eyebrow(text = ResKey.TEMPLATE10_TIMETABLE_EYEBROW)
                        Template10Title(text = ResKey.TEMPLATE10_TIMETABLE1_TITLE)
                    }
                    Template10PriceBadge()
                }
            }

            Template10Reveal(modifier = Modifier.fillMaxWidth(), delayMs = 100) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .overflow(Overflow.Auto)
                        .border(width = 1.px, style = LineStyle.Solid, color = Template10Theme.Line.rgb)
                        .borderRadius(12.px)
                        .backgroundColor(Template10Theme.PaperLight.rgb)
                ) {
                    Template10Table()
                }
            }
        }
    }
}

@Composable
private fun Template10PriceBadge() {
    Row(
        modifier = Modifier
            .gap(18.px)
            .backgroundColor(Template10Theme.Primary.getColor())
            .padding(topBottom = 18.px, leftRight = 26.px)
            .borderRadius(10.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Span(
            attrs = Modifier
                .template10HeadingFont()
                .fontSize(40.px)
                .fontWeight(FontWeight.ExtraBold)
                .lineHeight(1)
                .color(Colors.White)
                .toAttrs()
        ) {
            AnjurosText(
                Template10Constants.CLASS_PRICE,
                com.anjuros.website.components.language.ResKey.PLACEHOLDER_SERVICE_PRICE
            )
        }
        Span(
            attrs = Modifier
                .template10BodyFont()
                .fontSize(14.px)
                .fontWeight(FontWeight.SemiBold)
                .lineHeight(1.35)
                .color(Colors.White)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE10_PER_CLASS))
            Br()
            Text(LocalText(ResKey.TEMPLATE10_ALL_VENUES))
        }
    }
}

@Composable
private fun Template10Table() {
    Table(
        attrs = Modifier
            .fillMaxWidth()
            .minWidth(760.px)
            .styleModifier { property("border-collapse", "collapse") }
            .template10BodyFont()
            .fontSize(16.px)
            .color(Template10Theme.Ink.rgb)
            .toAttrs()
    ) {
        Thead {
            Tr(
                attrs = Modifier
                    .styleModifier { property("border-bottom", "2px solid ${Template10Theme.Ink.hex}") }
                    .toAttrs()
            ) {
                Th(
                    attrs = Modifier
                        .padding(topBottom = 24.px, leftRight = 28.px)
                        .styleModifier { property("width", "18%") }
                        .textAlign(TextAlign.Start)
                        .fontSize(13.px)
                        .letterSpacing(0.12.em)
                        .textTransform(TextTransform.Uppercase)
                        .color(Template10Theme.Muted.rgb)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.TEMPLATE10_CLASS_DAY))
                }
                Template10Venue.entries.forEach { venue ->
                    Th(
                        attrs = Modifier
                            .padding(topBottom = 24.px, leftRight = 28.px)
                            .textAlign(TextAlign.Start)
                            .toAttrs()
                    ) {
                        Div(
                            attrs = Modifier
                                .template10HeadingFont()
                                .fontSize(24.px)
                                .fontWeight(FontWeight.Bold)
                                .toAttrs()
                        ) {
                            AnjurosText(venue.city)
                        }
                        Div(
                            attrs = Modifier
                                .fontSize(13.px)
                                .fontWeight(FontWeight.Medium)
                                .color(Template10Theme.Muted.rgb)
                                .toAttrs()
                        ) {
                            AnjurosText(venue.address)
                        }
                    }
                }
            }
        }
        Tbody {
            template10Days.forEachIndexed { index, day ->
                Tr(
                    attrs = Modifier
                        .then(
                            if (index < template10Days.size - 1)
                                Modifier.styleModifier {
                                    property("border-bottom", "1px solid ${Template10Theme.LineSoft.hex}")
                                }
                            else Modifier
                        )
                        .toAttrs()
                ) {
                    Td(
                        attrs = Modifier
                            .padding(topBottom = 20.px, leftRight = 28.px)
                            .fontWeight(FontWeight.Bold)
                            .toAttrs()
                    ) {
                        Text(LocalText(day))
                    }
                    Template10Venue.entries.forEach { venue ->
                        Td(
                            attrs = Modifier
                                .padding(topBottom = 20.px, leftRight = 28.px)
                                .toAttrs()
                        ) {
                            Div(
                                attrs = Modifier
                                    .display(DisplayStyle.Flex)
                                    .flexWrap(FlexWrap.Wrap)
                                    .gap(8.px)
                                    .toAttrs()
                            ) {
                                venue.slots[day].orEmpty().forEach { slot ->
                                    Span(
                                        attrs = Modifier
                                            .backgroundColor(Template10Theme.PaperDark.rgb)
                                            .padding(topBottom = 6.px, leftRight = 12.px)
                                            .borderRadius(6.px)
                                            .toAttrs()
                                    ) {
                                        AnjurosText(
                                            slot,
                                            com.anjuros.website.components.language.ResKey.PLACEHOLDER_SERVICE_TIME
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
